import { Component } from '@angular/core'

import { ResearchService } from '../../services/research.service'
import { CommonModule } from '@angular/common'
import { TranslocoDirective } from '@jsverse/transloco'
import { ResearchSessionComponent } from './research-session/research-session.component'
import { ResearchSession } from '../../types'
import { ConfigService } from '../../services/config.service'

@Component({
   selector: 'app-research-history',
   standalone: true,
   imports: [CommonModule, TranslocoDirective, ResearchSessionComponent],
   templateUrl: './research-history.component.html',
   styles: ''
})
export class ResearchHistoryComponent {
   get days() {
      return this.config.currentConfig.researchHistoryDays
   }

   get qandaCount() {
      return this.research.qandaCount
   }

   get maxHistorySize() {
      return this.config.currentConfig.maxHistorySize
   }
   get shouldShowAlmostMaxSizeWarning() {
      return this.maxHistorySize - this.qandaCount <= 10 && this.maxHistorySize - this.qandaCount > 0
   }

   get shouldShowMaxSizeWarning() {
      return this.maxHistorySize - this.qandaCount <= 0
   }

   get shouldShowSessions() {
      return this.research.researchHistory.researchSessions.length > 0 && this.research.researchHistory.researchSessions.find(session => Number(session?.count) > 0)
   }

   get hasOlderSessions() {
      return this.researchHistory.older && Object.keys(this.researchHistory.older).length > 0
   }

   get saveSessionsEnabled() {
      return this.config.currentConfig.enableHistory
   }

   get anonymousUser() {
      return this.research.user.type === 'anonymous'
   }

   // return research sessions of today
   today(sessions: ResearchSession[]): ResearchSession[] {
      // filter sessions that are really only since 0:00 today
      const midnight = new Date()
      midnight.setHours(0, 0, 0, 0)

      const today = sessions.filter(session => new Date(session.creationDate) > midnight && Number(session?.count) > 0)
      today.sort((a, b) => new Date(b.creationDate).getTime() - new Date(a.creationDate).getTime())
      return today
   }

   lastXDays(days: number, sessions: ResearchSession[]): ResearchSession[] {
      const midnight = new Date()
      midnight.setHours(0, 0, 0, 0)
      const midnightXDaysAgo = new Date(Date.now() - days * 24 * 60 * 60 * 1000)
      midnightXDaysAgo.setHours(0, 0, 0, 0)

      const lastX = sessions.filter(session => new Date(session.creationDate) > midnightXDaysAgo && new Date(session.creationDate) < midnight && Number(session?.count) > 0)
      lastX.sort((a, b) => new Date(b.creationDate).getTime() - new Date(a.creationDate).getTime())
      return lastX
   }

   // TODO this should be memoized or created in ngOnInit after subscribing to a signal or observable - refactor!
   get researchHistory() {
      const midnightXDaysAgo = new Date(Date.now() - this.days * 24 * 60 * 60 * 1000)
      midnightXDaysAgo.setHours(0, 0, 0, 0)
      this.research.researchHistory.researchSessions.forEach(session => {
         !session.creationDate.endsWith('Z') ? session.creationDate += 'Z' : null
      })
      const older = this.research.researchHistory.researchSessions.filter(session => new Date(session.creationDate) < midnightXDaysAgo && Number(session?.count) > 0)
      // now split older into years
      const years: Record<number, ResearchSession[]> = {}
      older.forEach(session => {
         const year = new Date(session.creationDate).getFullYear()
         if (!years[year]) {
            years[year] = []
         }
         years[year].push(session)
      })
      return {
         today: this.today(this.research.researchHistory.researchSessions),
         lastxdays: this.lastXDays(this.days, this.research.researchHistory.researchSessions),
         older: Object.entries(years).map(([year, sessions]) => ({ year: +year, sessions })).sort((a, b) => b.year - a.year)
      }
   }

   get currentResearchSession() {
      return this.research.researchSession
   }

   constructor(private research: ResearchService, private config: ConfigService){

   }

}
